var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "w-full flex" }, [
    !_vm.isNewlyCreatedItem
      ? _c(
          "div",
          { staticClass: "flex w-full" },
          [
            _c(
              "Tooltip",
              {
                attrs: {
                  title: _vm.tooltipTitle,
                  variant: _vm.TooltipVariants.DARK,
                  tooltipClasses: "w-60",
                  placement: "top",
                },
              },
              [
                _vm.colorCode
                  ? _c("ColorCodeTriangle", {
                      attrs: { colorCode: _vm.colorCode },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "flex w-full items-center p-4",
                class: _vm.avatarsPadding,
              },
              [
                _c("SchedulerItemAvatar", {
                  staticClass: "mr-2",
                  attrs: { title: _vm.activityName },
                }),
                _c("div", { staticClass: "flex-grow w-6 text-sm" }, [
                  _c("div", { staticClass: "font-bold text-white truncate" }, [
                    _vm._v(_vm._s(_vm.activityName)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "text-white font-semibold truncate" },
                    [_vm._v(" " + _vm._s(_vm.projectInfo) + " ")]
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "new-activity flex items-center" },
          [
            _c(
              "span",
              { staticClass: "mr-4 text-white text-sm font-semibold" },
              [_vm._v("New Task")]
            ),
            _c("UiButton", {
              attrs: { buttonText: "Create", variant: "outline", size: "xxs" },
              on: {
                click: function ($event) {
                  return _vm.$emit("create", _vm.activity)
                },
              },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }